import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => {
    // Summary panels as soft stat cards (like the client portal): small title, muted labels with a coloured status
    // dot, bold values. Colours come from the shared tokens in modern.css.
    const dot = (color: string) => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 13,
        fontWeight: 500,
        color: 'var(--muted)',
        '&::before': { content: '""', width: 8, height: 8, borderRadius: '50%', background: color, flex: 'none' },
    });

    return ({
        card: {
            border: '0 !important',
            boxShadow: 'none !important',
            background: 'transparent !important',
            overflow: 'visible !important',
        },
        mainContainer: {
            flexDirection: 'row',
            alignItems: 'stretch', // Makes children stretch to fill height
            justifyContent: 'space-between', // Space between the subcontainers
            width: '100%',
            margin: 0,
            padding: 0,
            height: '100%',
        },
        subContainer: {
            background: 'var(--surface-muted)',
            borderRadius: 18,
            flexDirection: 'row',
            alignContent: 'flex-start',
            rowGap: 10,
            width: '100%',
            padding: '16px 18px',
            height: '100%',
            overflow: 'hidden', // Restrict content overflow
        },
        panelTitle: {
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: 'var(--faint)',
            marginBottom: 2,
        },
        gridRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            '& > :last-child': { fontWeight: 700, fontSize: 15, color: 'var(--ink)' },
        },
        refreshButton: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
        },
        lineText: dot('var(--line-strong)'),
        successText: dot('var(--ok)'),
        dangerText: dot('var(--bad)'),
        warningText: dot('var(--warn)'),
    })
});

export default useStyles;
